// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-nMp","title":"styles_title__1zQEt"};